import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Users, Briefcase, Handshake, Heart } from 'lucide-react';
import AdminUsersPage from './AdminUsersPage';

export default function AdminAllUsersPage({ embedded }) {
  const [activeTab, setActiveTab] = useState('staff');

  return (
    <div className="space-y-6">
      {!embedded && (
      <div>
        <h1 className="font-heading text-2xl font-bold flex items-center gap-2">
          <Users className="w-6 h-6" /> Users
        </h1>
        <p className="text-muted-foreground">All accounts associated with Ready Set STEM — staff, partners, parents & guardians</p>
      </div>
      )}

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="staff" className="flex items-center gap-2">
            <Briefcase className="h-4 w-4" /> Staff
          </TabsTrigger>
          <TabsTrigger value="partners" className="flex items-center gap-2">
            <Handshake className="h-4 w-4" /> Partners
          </TabsTrigger>
          <TabsTrigger value="parents" className="flex items-center gap-2">
            <Heart className="h-4 w-4" /> Parents/Guardians
          </TabsTrigger>
        </TabsList>

        <TabsContent value="staff" className="mt-4">
          <AdminUsersPage embedded defaultRole="staff" />
        </TabsContent>

        <TabsContent value="partners" className="mt-4">
          <AdminUsersPage embedded defaultRole="partner" />
        </TabsContent>

        <TabsContent value="parents" className="mt-4">
          <AdminUsersPage embedded defaultRole="parent" />
        </TabsContent>
      </Tabs>
    </div>
  );
}
